// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation-root-B77q6","ul":"Navigation-ul-oB8cP"};